import { ImResponse, storeHomeNVClient } from '..';

export enum AE_AUTH_ERROR_CODES {
  NO_PERMISSION = 1054, // 用户没店铺管理权限
  AUTH_CODE_ERROR = 1055, // 授权code失效、获取店铺信息失败
  OCCUPIED = 1005, // 店铺被其他org授权过
  CURRENT_ACCOUNT_NEED_CLIENT_ADD_STORE = 1058, // 当前账户需要在客户端中添加店铺
}

export interface AeAuthResult {
  isSuccess: boolean;
  successCount: number;
  storeIds: number[];
  redirectUrl?: string;
  errorCode?: AE_AUTH_ERROR_CODES;
}

const authAEShopByCode = (code: string) => {
  return storeHomeNVClient.post<ImResponse<AeAuthResult>>('/aliexpress/auth_shop_by_code', {
    code,
  });
};

export default authAEShopByCode;
